export default __webpack_public_path__ + "static/media/IMG_9975.f8be4cb8.jpeg";